
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"plus (1)","d":"M18.636 8.182h-6.818V1.364A1.364 1.364 0 0010.455 0h-.91a1.364 1.364 0 00-1.363 1.364v6.818H1.364A1.364 1.364 0 000 9.545v.909a1.364 1.364 0 001.364 1.364h6.818v6.818A1.364 1.364 0 009.545 20h.909a1.364 1.364 0 001.364-1.364v-6.818h6.818A1.364 1.364 0 0020 10.455v-.91a1.364 1.364 0 00-1.364-1.363zm0 0","fill":"#3e92cf"}})])
          )
        }
      }
    